// @flow
import React, { PureComponent } from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import request from '../../utils/Request'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import { API_WIDGETDATA_URI } from '../../../constants'
import Start from './StyledStart'
import Icon from './StyledIcon'
import List from './StyledList'
import Progress from './StyledProgress'
import ProgramLink from './StyledProgramLink'
import MoreLink from '../../utils/MoreLink'
import MoreLinkWrapper from '../../containers/StyledMoreLinkWrapper'
import { TextContainer, ProgressContainer } from './StyledContainers'
import { type TvProgramWidgetProps, type TvProgramWidgetState } from './Types'

declare var STATICS_PATH: string

const RELOAD_INTERVAL_MS = 120000

export default class TvProgram extends PureComponent<TvProgramWidgetProps, TvProgramWidgetState> {
  constructor (props: TvProgramWidgetProps) {
    super(props)

    const {
      widget: {
        boxes = []
      }
    } = props

    this.state = {
      boxes
    }
  }

  refreshingInterval: * = null

  componentDidMount () {
    this.refreshingInterval = setInterval(() => {
      const {
        widget: {
          name,
          boxesConfig
        }
      } = this.props
      const requestConfig = {
        url: API_WIDGETDATA_URI,
        method: 'post',
        data: {
          widgetConfig: {
            [name]: {
              boxesConfig
            }
          }
        }
      }

      request(requestConfig).then(response => {
        this.setState({
          boxes: response.data[name].boxes
        })
      }).catch(() => {})
    }, RELOAD_INTERVAL_MS)
  }

  componentWillUnmount () {
    clearInterval(this.refreshingInterval)
  }

  render () {
    const {
      embedded = false,
      widget,
      widget: {
        meta: {
          headline: {
            location: headlineLocation = ''
          } = {}
        } = {},
        utmMedium
      }
    } = this.props

    const {
      boxes
    } = this.state

    if (!boxes.length) {
      return null
    }

    const widgetContent = (
      <List>
        { boxes.map((box, index) => {
          const {
            channel: {
              icon
            },
            program: {
              start,
              title,
              progress,
              location
            }
          } = box
          const utmParams = {
            utmMedium,
            utmTerm: `position-${index + 1}`
          }
          const utmLink = utmLinkGenerator.createLink(location, utmParams)

          return (
            <li key={box.guid}>
              <TextContainer>
                <Icon src={`${STATICS_PATH}${icon}`} />
                <Start>
                  { start }
                </Start>
                <ProgramLink href={utmLink}>
                  { title }
                </ProgramLink>
              </TextContainer>
              <ProgressContainer>
                <Progress width={progress} />
              </ProgressContainer>
            </li>
          )
        })}
      </List>
    )

    if (embedded) {
      const widgetWithMoreLink = Object.assign({}, widget, {
        meta: {
          more: {
            text: 'Celý program',
            location: headlineLocation
          }
        }
      })

      return (
        <React.Fragment>
          { widgetContent }
          <MoreLinkWrapper>
            <MoreLink widget={widgetWithMoreLink}/>
          </MoreLinkWrapper>
        </React.Fragment>
      )
    } else {
      return (
        <WidgetContainer widget={widget}>
          { widgetContent }
        </WidgetContainer>
      )
    }
  }
}
